import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import config from 'src/core/config'
export default class {
  @observable data = {
    userInfo: {}
  }

  @action async GetUserInfoWeb(uid) {
    let d = await http.post('/web/MyAccountInfo', { uid: uid })
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
      return d && d.res
    }
  }

  @action async getNationList() {
    let res = await http.post('/withoutsign/country', {}, null, { "X-OsLang": navigator.language })
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }

  @action async verifyUser(uid) {
    let res = await http.post('/withoutsign/payermax/user/verify', { uid })
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }

  @action async priceList(id) {
    let res = await http.post('/withoutsign/payermax/product/list', { id })
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }

  @action async payList(countryId,rechargeRuby) {
    let n = 0
    if (config.host == 'https://api-test.thechatie.com' ) {
      n = 1
   }
    let res = await http.post('/withoutsign/payermax/method/list', { countryId ,rechargeRuby,paypalDisplay:1,razerDisplay:n})
    if (res && res.code == 0) {
      return res.res
    } else {
      return []
    }
  }
  @action async newPayList(countryId,rechargeRuby) {
    let n = 0
    if (config.host == 'https://api-test.thechatie.com' ) {
      n = 1
   }
    let res = await http.post('/withoutsign/payermax/agentgold', { countryId,rechargeRuby:rechargeRuby,paypalDisplay:1,razerDisplay:n})
    if (res && res.code == 0) {
      return res.res
    } else {
      return res
    }
  }
  @action async placeOrder({ uid, identifier, id, frontCallbackURL,rechargeRuby }) {
    let res = await http.post('/withoutsign/payermax/order/pay', { uid, identifier, id, frontCallbackURL,rechargeRuby })
    return res
  }
}


// WEBPACK FOOTER //
// src/store/app/recharge.js